<template>
  <div class="pt-panel card-detaile-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">陕西供水范围</h2>
        <p class="pt-subtitle">供水方案详情 · 分类统计</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-section">
      <div class="pt-section-title">
        <strong>供水方案明细</strong>
        <span>共 {{ supplyScheme.length }} 条记录</span>
      </div>

      <table class="pt-table">
        <thead>
        <tr>
          <th style="width: 14%;">类型</th>
          <th style="width: 44%;">对象</th>
          <th style="width: 14%;">取水量（万m³）</th>
          <th style="width: 14%;">备注</th>
        </tr>
        </thead>
      </table>

      <div class="pt-scroll" style="max-height: 500px;">
        <table class="pt-table">
          <tbody>
          <template v-for="(group, gIndex) in groupedData">
            <tr
                v-for="(line, i) in group.items"
                :key="gIndex + '-' + i"
            >
              <td
                  v-if="i === 0"
                  :rowspan="group.items.length"
                  style="width: 14%; color: #b8ecff; font-weight: 600;"
              >
                {{ group.type }}
              </td>
              <td style="width: 44%;">{{ line.supplyObject }}</td>
              <td style="width: 14%;">{{ line.flow }}</td>
              <td style="width: 14%;">{{ line.remark }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardDetaile",
  data() {
    return {
      supplyScheme: [
        { type: "城市", supplyObject: "渭南市、韩城市和宜川、合阳、澄城、大荔、富平、蒲城、白水7个县城", flow: 22962, remark: "全部（9个县城）" },
        { type: "农村人饮", supplyObject: "宜川、韩城、合阳、澄城、大荔、富平、蒲城、白水8个县", flow: 4633, remark: "全部（8县61个镇）" },
        { type: "工业园区", supplyObject: "宜川县秋林核心区+范湾产业集聚区", flow: 213, remark: "" },
        { type: "工业园区", supplyObject: "宜川县集义物流园区", flow: 92, remark: "" },
        { type: "工业园区", supplyObject: "宜川县交里（云岩）天然气加工区", flow: 172, remark: "" },
        { type: "工业园区", supplyObject: "韩城高新技术产业开发区", flow: 37, remark: "" },
        { type: "工业园区", supplyObject: "韩城龙亭空铁物流创新产业园", flow: 908, remark: "" },
        { type: "工业园区", supplyObject: "韩城经济技术开发区", flow: 4424, remark: "" },
        { type: "工业园区", supplyObject: "合阳经济技术开发区", flow: 634, remark: "" },
        { type: "工业园区", supplyObject: "澄城县经济技术开发区", flow: 1178, remark: "" },
        { type: "工业园区", supplyObject: "富平高新技术产业开发区", flow: 6238, remark: "" },
        { type: "工业园区", supplyObject: "富平庄里工业园区", flow: 4084, remark: "" },
        { type: "工业园区", supplyObject: "富平北部建材产业区", flow: 555, remark: "" },
        { type: "工业园区", supplyObject: "白水县高新技术产业开发区", flow: 1441, remark: "" },
        { type: "工业园区", supplyObject: "卤阳湖现代产业综合开发区", flow: 3611, remark: "" },
        { type: "工业园区", supplyObject: "蒲城高新技术产业开发区", flow: 7012, remark: "" },
        { type: "农灌", supplyObject: "东雷一期", flow: 28011, remark: "102.00 万亩" },
        { type: "农灌", supplyObject: "东雷二期", flow: 23541, remark: "85.50 万亩" },
        { type: "农灌", supplyObject: "石堡川", flow: 3557, remark: "16.40 万亩" },
        { type: "农灌", supplyObject: "交口", flow: 7878, remark: "28.89 万亩" },
        { type: "农灌", supplyObject: "泾惠渠", flow: 3128, remark: "11.00 万亩" },
        { type: "农灌", supplyObject: "洛惠渠", flow: 4442, remark: "20.00 万亩" },
        { type: "农灌", supplyObject: "桃曲坡", flow: 6036, remark: "23.12 万亩" },
        { type: "农灌", supplyObject: "薛峰", flow: 799, remark: "3.10 万亩" },
        { type: "农灌", supplyObject: "林皋", flow: 953, remark: "4.00 万亩" },
        { type: "农灌", supplyObject: "龙阳", flow: 1595, remark: "5.60 万亩" },
        { type: "农灌", supplyObject: "禹门口灌区", flow: 451, remark: "1.75 万亩" },
        { type: "农灌", supplyObject: "红旗水库灌区", flow: 593, remark: "2.22 万亩" },
        { type: "农灌", supplyObject: "盘河灌区", flow: 438, remark: "1.70 万亩" },
        { type: "农灌", supplyObject: "下寨灌区", flow: 627, remark: "2.20 万亩" },
        { type: "农灌", supplyObject: "石羊抽水灌区", flow: 740, remark: "2.60 万亩" },
        { type: "农灌", supplyObject: "韩河灌区", flow: 683, remark: "2.40 万亩" },
        { type: "农灌", supplyObject: "温泉灌区", flow: 522, remark: "2.50 万亩" },
        { type: "农灌", supplyObject: "大荔县五万亩以下中型灌区", flow: 2347, remark: "10.06 万亩" },
        { type: "农灌", supplyObject: "蒲城县五万亩以下中型灌区", flow: 954, remark: "3.35 万亩" },
        { type: "农灌", supplyObject: "澄城县五万亩以下中型灌区", flow: 836, remark: "4.00 万亩" },
        { type: "农灌", supplyObject: "白水县五万亩以下中型灌区", flow: 276, remark: "1.30 万亩" },
        { type: "农灌", supplyObject: "合阳县五万亩以下中型灌区", flow: 1029, remark: "3.85 万亩" },
        { type: "农灌", supplyObject: "合阳扩灌区", flow: 9727, remark: "38.71 万亩" },
        { type: "农灌", supplyObject: "澄城扩灌区", flow: 4071, remark: "19.76 万亩" },
        { type: "农灌", supplyObject: "富平扩灌区", flow: 6636, remark: "26.10 万亩" },
        { type: "农灌", supplyObject: "蒲城扩灌区", flow: 8254, remark: "32.46 万亩" },
        { type: "农灌", supplyObject: "白水县扩灌区", flow: 5179, remark: "23.27 万亩" },
        { type: "农灌", supplyObject: "韩城扩灌区", flow: 826, remark: "3.50 万亩" },
        { type: "农灌", supplyObject: "宜川扩灌区", flow: 2072, remark: "10.00 万亩" }
      ]
    };
  },
  computed: {
    groupedData() {
      const groups = {};
      this.supplyScheme.forEach(item => {
        if (!groups[item.type]) {
          groups[item.type] = { type: item.type, items: [] };
        }
        groups[item.type].items.push(item);
      });
      return Object.values(groups);
    }
  },
  methods: {
    closeClick() { this.$emit("infoClose"); }
  }
};
</script>

<style scoped>
.card-detaile-panel {
  width: 55%;
  height: 83%;
  position: absolute;
  left: 25%;
  top: 150px;
}
</style>
